import { ValuesOf } from "../../foundation/random";
import { StaticallyComposableHTML } from "../../foundation/template-helpers";
import { StartEndOptions } from "../start-end/start-end";
import { NatGenCombobox } from "./combobox";

/**
 * Autocomplete values for combobox.
 * @public
 */
export const ComboboxAutocomplete = {
    inline: "inline",
    list: "list",
    both: "both",
    none: "none",
} as const;

/**
 * Autocomplete type for combobox.
 * @public
 */
export type ComboboxAutocomplete = ValuesOf<typeof ComboboxAutocomplete>;

/**
 * Combobox configuration options
 * @public
 */
export type ComboboxOptions = StartEndOptions<NatGenCombobox> & {
    indicator?: StaticallyComposableHTML<NatGenCombobox>;
};
